/* Open the Froonze wishlist popup when the header wishlist icon is clicked.
   Froonze binds its own injected launchers at creation time, not via
   delegation, so the custom header icon (.ella-header__wishlist) needs its own
   handler. We delegate on document and call Froonze's public toggle at click
   time (Froonze loads async, so we check for it then). */
(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.ella-header__wishlist');
    if (!trigger) return;
    event.preventDefault();
    if (window.frcp && window.frcp.wishlist && typeof window.frcp.wishlist.toggleWidget === 'function') {
      window.frcp.wishlist.toggleWidget();
    }
  });
})();
